import { t } from "../../i18n";
import { useLocation, useNavigate } from "react-router-dom";
import { useProjectStore } from "../../state/projectStore";
import { useCadUi, type LayoutTab } from "../../state/cadUiStore";

/**
 * Layout (pafta düzeni) sekmeleri (22 px): Model · Akıllı tasarım · Metraj · Çizim · Rapor. Model/Metraj `cadUi.layout` ile ProjectPage içinde,
 * Rapor ayrı rota (`/proje/:id/rapor`); rapor sayfasındayken Model/Metraj'a tıklamak projeye döner.
 * e2e: aria-label "{label} paftası" (şeritteki "Rapor" düğmesiyle ad çakışmasın).
 */
export function LayoutTabs({ current }: { current: LayoutTab }): JSX.Element {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const project = useProjectStore((s) => s.project);
  const setLayout = useCadUi((s) => s.setLayout), setPropTab = useCadUi((s) => s.setPropTab), setRibbonTab = useCadUi((s) => s.setRibbonTab);
  const go = (id: LayoutTab): void => {
    if (!project) return;
    if (id === "report") { setRibbonTab("report"); nav(`/proje/${project.id}/rapor`); return; }
    const rt = useCadUi.getState().ribbonTab;
    if (id === "quantities" || id === "drawing") setRibbonTab(id); else if (rt === "quantities" || rt === "report" || rt === "drawing") setRibbonTab("home");
    setLayout(id);
    if (id === "quantities") setPropTab("quantities");
    if (pathname.endsWith("/rapor")) nav(`/proje/${project.id}`);
  };
  return (
    <div className="cad-layout-tabs flex items-end gap-0.5 h-[22px] px-2 bg-cad-chrome3 border-t border-cad-line shrink-0" aria-label={t("Pafta düzeni")}>
      {([["model", t("Model")], ["design", t("Akıllı tasarım")], ["quantities", t("Metraj")], ["drawing", t("Çizim")], ["report", t("Rapor")]] as const).map(([id, label]) => (
        <button key={id} type="button" aria-pressed={current === id} aria-label={`${label} ${t("paftası")}`} onClick={() => go(id)}
          className={`cad-layout-tab h-[21px] px-2.5 text-[11px] whitespace-nowrap border border-cad-line border-b-0 cursor-pointer ${current === id ? "bg-cad-panel text-cad-accent font-medium" : "bg-cad-chrome1 text-cad-ink3"}`}>{label}</button>
      ))}
    </div>
  );
}
